export enum PlanDetailsId {
  Overview = "overview",
  BenefitsAndCosts = "benefits",
  DrugCoverage = "drug-coverage",
  ExtraBenefits = "extra-benefits",
  OptionalPackages = "optional-packages",
  StarRatings = "star-ratings",
  Providers = "providers",
  MaxYouPay = "max-you-pay",
  PlanInfo = "plan-details-plan-info",
}
